import { useSignedInAccount } from "../../auth/useSignedInAccount.js";
import { useSaveStatus } from "../../api/saveStatus.js";
import { IconButton } from "../ui/IconButton.js";
import type { SettingsSection } from "./SettingsModal.js";
import { useQuery } from "../../api/useQuery.js";
import { getCreditBalance } from "../../api/queries.js";
import { Icon, useT } from "@mmm/ui";
export function TopBar({ onOpenSettings }: { onOpenSettings: (section?: SettingsSection) => void }) {
  const account = useSignedInAccount();
  const saveStatus = useSaveStatus();
  const t = useT();
  const creditBalance = useQuery(getCreditBalance, undefined);
  const creditLabel = creditBalance.data && !creditBalance.error
    ? `${creditBalance.data.available} ${t("settings.section.credits")}`
    : t("credits.unavailable");
  const saving = saveStatus === "saving";
  const failed = saveStatus === "failed";
  const statusLabel = saving ? t("common.savingChanges") : failed ? t("common.saveFailedOpenSettings") : "";
  return <header className="mmm-topbar">
    <a href="/dashboard" className="mmm-topbar-brand" aria-label={t("nav.home")}>
      <img src="/favicon.svg" alt="" />
      <span className="mmm-topbar-wordmark">{t("brand.map")} <strong>{t("brand.my")}</strong> {t("brand.mind")}</span>
    </a>
    <div className="mmm-topbar-status" role="status" aria-live="polite">
      {(saving || failed) && <Icon name="save" />}
      <span>{statusLabel}</span>
    </div>
    <button type="button" className="mmm-topbar-credits" aria-label={creditLabel} title={t("settings.section.credits")} onClick={() => onOpenSettings("credits")}>
      <Icon name="credit" />
      <span>{creditBalance.data && !creditBalance.error ? creditBalance.data.available : t("credits.unavailable")}</span>
    </button>
    <button type="button" className="mmm-topbar-earn" onClick={() => onOpenSettings("earn")}>{t("settings.section.earn")}</button>
    <IconButton icon="settings" label={t("settings.title")} onClick={() => onOpenSettings()} />
    <button type="button" className="mmm-topbar-account" aria-label={account?.name ?? t("settings.accountFallbackName")} onClick={() => onOpenSettings()}>
      <span className="mmm-sidebar-avatar">{account?.initials ?? "?"}</span>
      <span className="mmm-topbar-account-name">{account?.name ?? t("settings.accountFallbackName")}</span>
    </button>
  </header>;
}
